/**
 * Textos (ca) de planta — OBR-87: recepció sense comanda prèvia: namespace `planta.receptionDirect`.
 * Tall propi: no es toca `ca.ts`. Les tres llengües han de tenir les mateixes claus (i18n.test.ts) i les mateixes
 * variables. Vocabulari del sector: «Existències», mai «Stock».
 */

export const receptionDirectCa = {
  'planta.receptionDirect': {
    // ── Permís: qui pot rebre sense comanda (admin, compres, operari: el que el servidor deixa escriure) ──
    noPermission:
      'Només l’administració, compres i els operaris poden registrar una recepció sense comanda.',

    // ── Proveïdor: l’única exigència dura (la llista és al dispositiu: triar-lo no demana connexió) ──
    supplierRequired: 'Tria el proveïdor abans de confirmar la recepció.',
    supplierFirstHint: 'Tria primer el proveïdor: només s’hi ofereixen els seus articles.',
    supplierChange: 'Canvia',

    // ── Proveïdor: dur, però mai mut (què fer segons el cas), cerca i canvi sense perdre res en silenci ──
    suppliersNoneOnDevice:
      'Aquest dispositiu no té cap proveïdor. Connecta’t i sincronitza per baixar els proveïdors.',
    supplierNotListedHint:
      'Si el proveïdor no hi és, demana a Compres que el doni d’alta al BackOffice.',
    supplierSearch: 'Cerca un proveïdor',
    supplierSearchNoMatch: 'Cap proveïdor coincideix amb la cerca.',
    supplierChangeTitle: 'Canviar a {{supplier}}?',
    supplierChangeLoses_one: 'Es perdrà {{count}} línia d’aquest albarà.',
    supplierChangeLoses_other: 'Es perdran les {{count}} línies d’aquest albarà.',
    supplierChangeKeep: 'No canviïs',
    supplierChangeConfirm: 'Canvia i treu les línies',

    // ── Lot del proveïdor: exigit, amb sortida (mai atrapat) ──
    lotMissing: 'Falta el lot del proveïdor d’aquesta entrada.',
    lotMissingSummary_one:
      'Falta el lot del proveïdor d’{{count}} entrada. Escriu-lo o confirma sense lot.',
    lotMissingSummary_other:
      'Falta el lot del proveïdor de {{count}} entrades. Escriu-los o confirma sense lot.',
    lotAndExpiryMissingSummary:
      'Falten el lot del proveïdor i la caducitat d’alguna entrada. Omple’ls o confirma igualment.',
    confirmWithoutLot: 'Confirma sense lot del proveïdor',
    confirmWithoutLotHint:
      'Si no el saps, pots confirmar igualment: el gènere entra amb el lot intern, però sense el lot del proveïdor. Quedarà apuntat al registre d’activitat.',
    confirmWithoutBoth: 'Confirma sense lot ni caducitat',
    confirmWithoutBothHint:
      'Si no ho saps, pots confirmar igualment: el gènere entra amb el lot intern, sense el lot del proveïdor ni la caducitat. L’existència queda a «A regularitzar» fins que s’hi posi la caducitat. Quedarà apuntat al registre d’activitat.',

    // ── Selector d’articles: sortida quan el proveïdor no en té de vinculats ──
    pickerShowAll: 'Mostra tots els articles',
    pickerShowSupplierOnly: 'Només els articles d’aquest proveïdor',
  },
} as const;
